// import React from "react";
// import "./ReportDetails.css"; // Ensure this is imported if using a separate CSS file
// import CircularInitial from "../../UpcomingRent/CircularInitial"; // Assuming CircularInitial is imported from this path
// import { IoCloseCircleOutline } from "react-icons/io5";
// import { FaWhatsapp } from "react-icons/fa";
// import { IoIosCall } from "react-icons/io";

// const ReportDetails = ({ tenantData, onClose, onMarkAsPaidClick }) => {
//   const {
//     first_name,
//     last_name,
//     unit_name,
//     building_name,
//     due_in,
//     local_amount,
//     due_date,
//     mobile,
//   } = tenantData;

//   console.log("TenantData", tenantData);
//   const handleWhatsAppClick = () => {
//     window.open(`https://wa.me/${mobile}`, "_blank");
//   };

//   return (
//     <div className="report-details-modal">
//       <div className="report-details-modal-content">
//         <IoCloseCircleOutline
//           size={35}
//           style={{ float: "right", cursor: "pointer" }}
//           onClick={onClose}
//         />

//         <h2 className="report-details-modal-header">Report Details</h2>

//         <div className="report-details-info">
//           <div className="report-details-details flex flex-col items-center justify-center p-4 gap-2">
//             <CircularInitial
//               firstName={tenantData.first_name}
//               lastName={tenantData.lastName}
//             />

//             <p style={{ fontSize: "18px" }}>
//               {first_name} {last_name}
//             </p>
//             <p>
//               {unit_name}, {building_name}
//             </p>
//             <p>{local_amount}</p>
//             <p>
//               {due_date}{" "}
//               {due_in === "Overdue" && (
//                 <span style={{ color: "red" }}>Overdue</span>
//               )}
//             </p>
//             <div className="contact-info">
//               <p className="flex items-center justify-center gap-2">
//                 {mobile} <IoIosCall size={20} color="blue" />{" "}
//                 <FaWhatsapp
//                   size={20}
//                   color="green"
//                   onClick={handleWhatsAppClick}
//                 />
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="report-details-modal-actions">
//           <button
//             className="report-details-overdue-button"
//             onClick={onMarkAsPaidClick}
//             style={{
//               border: "1px solid",
//               padding: "10px 40px",
//               borderRadius: "10px",
//               backgroundColor: "#0D1142",
//               fontWeight: 700,
//               color: "white",
//               margin: "5px",
//             }}
//           >
//             Mark as Paid
//           </button>
//           <button
//             className="flex items-center gap-2"
//             style={{
//               border: "1px solid",
//               padding: "10px 40px",
//               borderRadius: "10px",
//               backgroundColor: "#0D1142",
//               fontWeight: 700,
//               color: "white",
//               margin: "5px",
//             }}
//             onClick={handleWhatsAppClick}
//           >
//             <FaWhatsapp size={20} color="lightgreen" />
//             Send Reminder
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportDetails;

import React from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosCall } from "react-icons/io";
import {
  MdLocationOn,
  MdCalendarToday,
  MdAccountBalance,
} from "react-icons/md";
import CircularInitial from "../../UpcomingRent/CircularInitial";

const ReportDetails = ({ tenantData, onClose, onMarkAsPaidClick }) => {
  // Debug: Log the tenant data being received
  console.log("🐛 ReportDetails: tenantData received:", tenantData);

  if (!tenantData) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              No Data Available
            </h2>
            <p className="text-gray-600 mb-4">
              Unable to load tenant information.
            </p>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  const {
    first_name,
    last_name,
    unit_name,
    building_name,
    due_in,
    local_amount,
    amount,
    due_date,
    mobile,
    month,
    year,
    nature,
  } = tenantData;

  const handleWhatsAppClick = () => {
    if (mobile) {
      window.open(`https://wa.me/${mobile}`, "_blank");
    }
  };

  const handleCallClick = () => {
    if (mobile) {
      window.open(`tel:${mobile}`, "_self");
    }
  };

  // Fixed: Pass tenantData to the mark as paid handler
  const handleMarkAsPaidClick = () => {
    console.log("🔄 Mark as Paid clicked, passing tenant data:", tenantData);
    onMarkAsPaidClick(tenantData); // ✅ Now passing the tenant data
  };

  const formatAmount = (amount, localAmount) => {
    if (localAmount) return localAmount;
    if (amount) return `₹${parseInt(amount).toLocaleString("en-IN")}`;
    return "Amount not available";
  };

  const getPaymentStatus = (dueIn) => {
    if (dueIn === "Overdue") {
      return { text: "Overdue", color: "text-red-600", bgColor: "bg-red-100" };
    } else if (dueIn && dueIn.includes("day")) {
      return {
        text: `Due in ${dueIn}`,
        color: "text-yellow-600",
        bgColor: "bg-yellow-100",
      };
    }
    return { text: "Due", color: "text-gray-600", bgColor: "bg-gray-100" };
  };

  const paymentStatus = getPaymentStatus(due_in);
  const tenantName =
    `${first_name || ""} ${last_name || ""}`.trim() || "Unknown Tenant";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">Payment Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <IoCloseCircleOutline size={28} />
          </button>
        </div>

        {/* Tenant Profile Section */}
        <div className="p-6 text-center bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="mb-4">
            <CircularInitial
              firstName={first_name}
              lastName={last_name}
              size="large"
            />
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {tenantName}
          </h3>

          <div className="space-y-2 text-gray-600">
            <div className="flex items-center justify-center gap-2">
              <MdLocationOn className="text-gray-500" size={16} />
              <span className="text-sm">
                {unit_name}, {building_name}
              </span>
            </div>

            {mobile && (
              <div className="flex items-center justify-center gap-3">
                <span className="text-sm font-medium">{mobile}</span>
                <button
                  onClick={handleCallClick}
                  className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200 transition-colors"
                  title="Call"
                >
                  <IoIosCall size={16} />
                </button>
                <button
                  onClick={handleWhatsAppClick}
                  className="p-2 bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
                  title="WhatsApp"
                >
                  <FaWhatsapp size={16} />
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Payment Information */}
        <div className="p-6 space-y-4">
          {/* Amount */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MdAccountBalance className="text-gray-500" size={20} />
                <span className="text-sm font-medium text-gray-700">
                  {nature === "security_deposit"
                    ? "Security Deposit"
                    : "Rent Amount"}
                </span>
              </div>
              <span className="text-2xl font-bold text-green-600">
                {formatAmount(amount, local_amount)}
              </span>
            </div>
          </div>

          {/* Due Date */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MdCalendarToday className="text-gray-500" size={20} />
                <span className="text-sm font-medium text-gray-700">
                  Due Date
                </span>
              </div>
              <div className="text-right">
                <div className="text-sm font-medium text-gray-900">
                  {due_date}
                </div>
                <span
                  className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${paymentStatus.bgColor} ${paymentStatus.color}`}
                >
                  {paymentStatus.text}
                </span>
              </div>
            </div>
          </div>

          {/* Period */}
          {month && year && (
            <div className="bg-gray-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">
                  Period
                </span>
                <span className="text-sm font-medium text-gray-900">
                  {month} {year}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="p-6 border-t border-gray-200 space-y-3">
          <button
            onClick={handleMarkAsPaidClick}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Mark as Paid
          </button>

          {mobile && (
            <button
              onClick={handleWhatsAppClick}
              className="w-full flex items-center justify-center gap-2 bg-green-500 text-white font-semibold py-3 px-6 rounded-lg hover:bg-green-600 transition-colors"
            >
              <FaWhatsapp size={18} />
              Send Payment Reminder
            </button>
          )}

          <button
            onClick={onClose}
            className="w-full border border-gray-300 text-gray-700 font-medium py-3 px-6 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
